import React from 'react';
import {
    Labeled, BooleanInput, Field, required, DateTimeInput, Edit, NumberInput, TextInput, number, LongTextInput, SimpleForm, TabbedForm,
    FormTab, useTranslate
} from 'react-admin';
// import RichTextInput from 'ra-input-rich-text';
import Button from '@material-ui/core/Button';
import { ShowButton, SaveButton, Toolbar, TopToolbar } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import frLocale from "date-fns/locale/fr";

const EditActions = ({ basePath, data, resource }) => (
    <TopToolbar>
        {/* <ShowButton basePath='/view-my-profile' record={data} /> */}
        {/* <Button color="primary" onClick={customAction}>Custom Action</Button> */}
    </TopToolbar>
);

const validateTimeFormat = (value, allValues) => {
    // console.log("All values " + allValues['oc_from_mon']);
    if (value.length !== 5) {
        return 'Doit être au format ab:xy, par exemple: 06:15';
    }

    const vals = value.split(":");
    if (vals.length !== 2) {
        return 'Doit être au format ab:xy, par exemple: 06:15';
    }

    if (isNaN(+vals[0]) || isNaN(+vals[1])) {
        return 'Doit être au format ab:xy tandis que ab et xy sont des nombres, par exemple: 06:15';
    }

    if (+vals[0] < 0 || +vals[0] > 23) {
        return "Doit être au format ab:xy tandis que ab est l'heure du jour, de 00 à 23";
    }

    if (+vals[1] < 0 || +vals[1] > 59) {
        return "Doit être au format ab:xy tandis que xy est la minute, de 00 à 59";
    }


    return [];
};

const validateTimeSlotMon = (value, allValues) => {
    // console.log("validateTimeSlotMon " + allValues['oc_from_mon'] + " - " + allValues['oc_to_mon'] );

    var result = validateTimeFormat(value, allValues);
    if (result !== []) {
        if (typeof (allValues['oc_10']) !== 'undefined' && typeof (allValues['oc_11']) !== 'undefined' &&

            allValues['oc_10'] !== 'undefined' && allValues['oc_11'] !== 'undefined' && +(allValues['oc_10'].replace(":", "")) > +(allValues['oc_11'].replace(":", ""))) {
            return "L'heure d'ouverture doit ne plus être plus tard que l'heure de fermeture";
        }
    }

    return result;
};

const validateTimeSlotTue = (value, allValues) => {
    // console.log("validateTimeSlotTue " + allValues['oc_from_mon'] + " - " + allValues['oc_to_mon'] );
    var result = validateTimeFormat(value, allValues);
    if (result !== []) {

        if (typeof (allValues['oc_20']) !== 'undefined' && typeof (allValues['oc_21']) !== 'undefined' && allValues['oc_20'] !== 'undefined' && allValues['oc_21'] !== 'undefined' && +allValues['oc_20'].replace(":", "") > +allValues['oc_21'].replace(":", "")) {
            return "L'heure d'ouverture doit ne plus être plus tard que l'heure de fermeture";
        }
    }

    return result;
};


const validateTimeSlotWed = (value, allValues) => {
    var result = validateTimeFormat(value, allValues);
    if (result !== []) {
        if (typeof (allValues['oc_30']) !== 'undefined' && typeof (allValues['oc_31']) !== 'undefined' &&
            allValues['oc_30'] !== 'undefined' && allValues['oc_31'] !== 'undefined' && +allValues['oc_30'].replace(":", "") > +allValues['oc_31'].replace(":", "")) {
            return "L'heure d'ouverture doit ne plus être plus tard que l'heure de fermeture";
        }

    }

    return result;
};

const validateTimeSlotThu = (value, allValues) => {
    var result = validateTimeFormat(value, allValues);
    if (result !== []) {
        if (typeof (allValues['oc_40']) !== 'undefined' && typeof (allValues['oc_41']) !== 'undefined' &&
            allValues['oc_40'] !== 'undefined' && allValues['oc_41'] !== 'undefined' &&
            +allValues['oc_40'].replace(":", "") > +allValues['oc_41'].replace(":", "")) {
            return "L'heure d'ouverture doit ne plus être plus tard que l'heure de fermeture";
        }

    }

    return result;
};

const validateTimeSlotFri = (value, allValues) => {
    var result = validateTimeFormat(value, allValues);
    if (result !== []) {
        if (typeof (allValues['oc_50']) !== 'undefined' && typeof (allValues['oc_51']) !== 'undefined' &&
            allValues['oc_50'] !== 'undefined' && allValues['oc_51'] !== 'undefined' &&
            +allValues['oc_50'].replace(":", "") > +allValues['oc_51'].replace(":", "")) {
            return "L'heure d'ouverture doit ne plus être plus tard que l'heure de fermeture";
        }

    }

    return result;
};

const validateTimeSlotSat = (value, allValues) => {
    var result = validateTimeFormat(value, allValues);
    if (result !== []) {
        if (typeof (allValues['oc_50']) !== 'undefined' && typeof (allValues['oc_51']) !== 'undefined' &&
            allValues['oc_50'] !== 'undefined' && allValues['oc_51'] !== 'undefined' &&
            +allValues['oc_50'].replace(":", "") > +allValues['oc_51'].replace(":", "")) {
            return "L'heure d'ouverture doit ne plus être plus tard que l'heure de fermeture";
        }

    }

    return result;
};

const validateTimeSlotSun = (value, allValues) => {
    var result = validateTimeFormat(value, allValues);
    if (result !== []) {
        if (typeof (allValues['oc_60']) !== 'undefined' && typeof (allValues['oc_61']) !== 'undefined' &&
            allValues['oc_60'] !== 'undefined' && allValues['oc_61'] !== 'undefined' &&
            +allValues['oc_60'].replace(":", "") > +allValues['oc_61'].replace(":", "")) {
            return "L'heure d'ouverture doit ne plus être plus tard que l'heure de fermeture";
        }

    }

    return result;
};

const validateTimeInputMon = [required(), validateTimeSlotMon];
const validateTimeInputTue = [required(), validateTimeSlotTue];
const validateTimeInputWed = [required(), validateTimeSlotWed];
const validateTimeInputThu = [required(), validateTimeSlotThu];
const validateTimeInputFri = [required(), validateTimeSlotFri];
const validateTimeInputSat = [required(), validateTimeSlotSat];
const validateTimeInputSun = [required(), validateTimeSlotSun];

const OpenTimeInputMon = ({ label, sourceFrom, sourceTo }) => (
    <Labeled label={label}>
        <span>
            <TextInput source={sourceFrom} label="Ouverture" validate={validateTimeInputMon} />
            &nbsp;
            <TextInput source={sourceTo} label="Fermeture" validate={validateTimeInputMon} />
        </span>
    </Labeled>
);

const OpenTimeInput = ({ label, sourceFrom, sourceTo, validation }) => (
    <Labeled label={label}>
        <span>
            <TextInput source={sourceFrom} label="Ouverture" validate={validation} />
            &nbsp;
            <TextInput source={sourceTo} label="Fermeture" validate={validation} />
        </span>
    </Labeled>
);

const EditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="Enregistrer"
            redirect="/config"
            submitOnEnter={true}
        />

    </Toolbar>
);

const Title = ({ record }) => {
    const translate = useTranslate();
    return <span>{translate('menu.settings')}</span>;
};

const validateNotSmallerThanOne = (value, allValues) => {
    if (value < 1) {
        return 'Doit ne pas être moins que 1';
    }
    return [];
};

const validatePositive = (value, allValues) => {
    if (value <= 0) {
        return 'Doit être plus grand que 0';
    }
    return [];
};

const validateNotPositive = (value, allValues) => {
    if (value < 0) {
        return 'Doit être positif';
    }
    return [];
};

// const validateGreaterThanZero = (value, allValues) => {
//     if (value < 1) {
//         return 'Doit être au moins 1';
//     }
//     return [];
// };

const validatePositiveNumber = [required(), number(), validatePositive];
const validateNotNegativeNumber = [required(), number(), validateNotPositive];
const validateNotSmallerThanOneNumber = [required(), number(), validateNotSmallerThanOne];
// const validateMaxCount = [required(), number(), validateGreaterThanZero];

// const EditConfig = ({ staticContext, ...props }) => {
const EditConfig = props => {
    return (
        <Edit
            actions={<EditActions />}
            id='noid'
            resource="config"
            basePath="/config"
            redirect="false"
            title={<Title />}
            {...props}
        >

            {/* <SimpleForm redirect="list">
                
            <TextInput source="currency_code" label="Code de monnaie"/>
            

        </SimpleForm> */}
            <TabbedForm toolbar={<EditToolbar />}>
                <FormTab label="Paramètres">
                    {/* <TextInput source="currency_code" label="Code de monnaie"/>
                <TextInput source="currency_symbol" label="Symbole de monnaie"/> */}
                    {/* <TextInput source="unit_time" label="Symbole de monnaie"/> */}
                    <NumberInput source="commission" label="Commission service (%)" validate={validateNotNegativeNumber} />
                    {/* <NumberInput source="vat_2" label="TVA Personne physique(%)" validate={validateNotNegativeNumber}/>
                 */}
                    <NumberInput source="delivery_fee" label="Frais de livraison (€)" validate={validateNotNegativeNumber} />
                    <NumberInput source="cancel_fee" label="Frais d'annulation (€)" validate={validateNotNegativeNumber} />
                    <NumberInput source="partner_delay" label="Délai d'envoi aux partenaires (minutes)" validate={validateNotNegativeNumber} style={{ 'width': '600px' }} />
                    <NumberInput source="vat" label="TVA (%)" validate={validateNotNegativeNumber} />
                    <TextInput source="postal_codes" label="Codes postaux pour la disponibilité" fullWidth />
                    <TextInput source="postal_code_error" label="Message pour valider le code postal" fullWidth multiline='true' />
                    {/* <NumberInput source="vat" label="TVA (%)" validate={validateNotNegativeNumber}/> */}
                    {/* <NumberInput source="dollar_gn" label="$ en GNF" validate={validateNotNegativeNumber}/> */}
                    {/* <NumberInput source="doc_validation_warning_before" label="Informé pour l'expiration de documents avant (jours)"  
                initialValue={1} style={{'width':'600px'}}
                validate={validateNotSmallerThanOneNumber}/> */}
                </FormTab>
                <FormTab label="Disponibilité">
                    <BooleanInput source="client_register_enabled" label="Inscription des clients" />
                    <BooleanInput source="solo_client_order_create_enabled" label="Création des commandes des clients solo" />
                </FormTab>
                <FormTab label="Ouverture/Fermeture">
                    {/* <TextInput source="currency_code" label="Code de monnaie"/>
                <TextInput source="currency_symbol" label="Symbole de monnaie"/> */}
                    {/* <TextInput source="unit_time" label="Symbole de monnaie"/> */}
                    {/* <NumberInput source="commission" label="Commission service (%)" validate={validateNotNegativeNumber}/> */}
                    {/* <NumberInput source="vat_2" label="TVA Personne physique(%)" validate={validateNotNegativeNumber}/>
                <NumberInput source="vat_6" label="TVA Société(%)" validate={validateNotNegativeNumber}/> */}
                    {/* <TextInput source="monday" label="Lundi"/> */}
                    <OpenTimeInputMon sourceFrom="oc_10" sourceTo="oc_11" label="Lundi" />
                    <OpenTimeInput sourceFrom="oc_20" sourceTo="oc_21" label="Mardi" validation={validateTimeInputTue} />
                    <OpenTimeInput sourceFrom="oc_30" sourceTo="oc_31" label="Mercredi" validation={validateTimeInputWed} />
                    <OpenTimeInput sourceFrom="oc_40" sourceTo="oc_41" label="Jeudi" validation={validateTimeInputThu} />
                    <OpenTimeInput sourceFrom="oc_50" sourceTo="oc_51" label="Vendredi" validation={validateTimeInputFri} />
                    <OpenTimeInput sourceFrom="oc_60" sourceTo="oc_61" label="Samedi" validation={validateTimeInputSat} />
                    <OpenTimeInput sourceFrom="oc_70" sourceTo="oc_71" label="Dimanche" validation={validateTimeInputSun} />
                    {/* <TextInput source="oc_from_mon" label="Lundi"/>
                <TextInput source="oc_tue" label="Mardi"/>
                <TextInput source="oc_wed" label="Mecredi"/>
                <TextInput source="oc_thu" label="Jeudi"/>
                <TextInput source="oc_fri" label="Vendredi"/>
                <TextInput source="oc_sat" label="Samedi"/>
                <TextInput source="oc_sun" label="Dimanche"/> */}
                    {/* <NumberInput source="vat" label="TVA (%)" validate={validateNotNegativeNumber}/> */}
                    {/* <NumberInput source="dollar_gn" label="$ en GNF" validate={validateNotNegativeNumber}/> */}
                    {/* <NumberInput source="doc_validation_warning_before" label="Informé pour l'expiration de documents avant (jours)"  
                initialValue={1} style={{'width':'600px'}}
                validate={validateNotSmallerThanOneNumber}/> */}
                </FormTab>
                <FormTab label="Contenu partagé">
                    <TextInput source="web_url_fb" label="Page web partagée sur Facebook" fullWidth />
                    <TextInput source="content_fb" label="Contenu partagé sur Facebook" fullWidth multiline='true' />
                    <TextInput source="content_wp" label="Contenu partagé sur Whatsapp" fullWidth multiline='true' />

                </FormTab>
                {/* <FormTab label="Commande"> */}

                {/* <TextInput fullWidth source="manual_dispatch_postal_codes" style={{'width':'50%'}} helperText="Exemple: 13001-13999, 14000, 14007. Tandis que 13001-13999 pour les codes postaux de 13001 à 13000. 14000 et 14007 sont des valuers individuelles. Séparées par des virgules"
                    label="Zones (codes postaux) pour le dispatching manuel"/> */}
                {/* <NumberInput source="timeout_order_wait_for_accept" label="Immédiate - Délai d'acceptation (secondes)" validate={validatePositiveNumber} style={{'width':'600px'}}/>
                <NumberInput source="timeout_reservation_wait_for_accept" label="Réservation - Délai d'acceptation (minutes) avant la prise en charge" validate={validatePositiveNumber} style={{'width':'600px'}}/> */}
                {/* <NumberInput source="order_free_wait_min" label="Temps d'attente gratuit (minutes)" validate={validateNotNegativeNumber} style={{'width':'600px'}}/>
                <NumberInput source="wait_price" label="Prix d'attente (€/minute)" initialValue={0} validate={required()} style={{'width':'600px'}}/> */}
                {/* <NumberInput source="cancel_free_driver" label="Temps d'annulation gratuit(s) du chauffeur" validate={required()} style={{'width':'600px'}}/>
                <NumberInput source="cancel_free_client" label="Temps d'annulation gratuit(s) du client" validate={required()} style={{'width':'600px'}}/> */}

                {/* <NumberInput source="service_avail_center_lat" label="Latitude du centre du service" validate={[required()]} style={{'width':'25%'}}/>
                <NumberInput source="service_avail_center_lng" label="Longitude du centre du service" validate={[required()]} style={{'width':'25%'}}/>
                <NumberInput source="service_avail_radius" label="Rayon du service(km)" validate={validateNotNegativeNumber} style={{'width':'25%'}}/>
                 */}

                {/* <Typography variant="h6" gutterBottom>Immédiate</Typography> */}
                {/* <NumberInput source="pick_up_radius" label="Rayon autour point de départ(km) pour recevoir la commande" validate={required()} style={{'width':'600px'}}/> */}
                {/* <NumberInput source="wait_radius" label="Rayon autour point de départ(m) pour l'attente" validate={required()} style={{'width':'600px'}}/>
                <NumberInput source="dispose_radius" label="Rayon autour point de dépose(m) pour l'alerte" validate={required()} style={{'width':'600px'}}/> */}


                {/* <Typography variant="h6" gutterBottom>Réservation à l'avance</Typography> */}
                {/* <NumberInput source="soonest_reservation_time" label="Heure de réservation au plus tôt (minutes)" validate={validateNotNegativeNumber} style={{'width':'600px'}}/>
                <NumberInput source="latest_reservation_time" label="Heure de réservation au plus tard (minutes)" validate={validateNotNegativeNumber} style={{'width':'600px'}}/> */}
                {/* </FormTab> */}

                {/* <FormTab label="Code de réduction">
                <TextInput source="first_order_promo_code_value" label="Valeur du code de réduction pour le nouveau compte client" fullWidth validate={required()}/>
                
            </FormTab> */}
                {/* <FormTab label="Comptes">
                <TextInput source="system.mail.sender" label="Expéditeur" validate={required()}/>
                <TextInput source="system.mail.receiver" label="Destinataire" validate={required()}/>
            </FormTab> */}


                <FormTab label="Coordonnées">
                    <TextInput source="company_name" label="Nom" validate={required()} fullWidth />
                    <TextInput source="company_address_line1" label="Adresse ligne 1" validate={required()} fullWidth multiline />
                    <TextInput source="company_address_line2" label="Adresse ligne 2" validate={required()} fullWidth multiline />
                    <TextInput source="capital" label="Capital (euros)" />
                    <TextInput source="siret" label="SIRET" />
                    <TextInput source="cee" label="N/Id CEE" />
                    <TextInput source="iban" label="IBAN (pour le paiment différé)" fullWidth />
                    <TextInput source="company_email" label="Email" />
                    <TextInput source="company_phone" label="Téléphone" />
                    <TextInput source="contact_email" label="Email de contact" />
                    <TextInput source="register_email" label="Email pour l'inscription" />

                </FormTab>


            </TabbedForm>


        </Edit>
    );
};

export default EditConfig;
